// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3Lrix","label":"LabeledBox_label__1-u7S"};